import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const FAQ_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'faq'

export const faq = Object.freeze({
  async fetchList(params) {
    const response = await axiosInstance.get(`${FAQ_URL}/${ENTITY}/list`, { params })
    return response.data
  },
  async fetchItem(id) {
    const response = await axiosInstance.get(`${FAQ_URL}/${ENTITY}/${id}`)
    return response.data
  },
  async create(data) {
    const response = await axiosInstance.post(`${FAQ_URL}/${ENTITY}`, data)
    return response.data
  },
  async update(data) {
    const response = await axiosInstance.put(`${FAQ_URL}/${ENTITY}`, data)
    return response.data
  },
  async remove(id) {
    const response = await axiosInstance.delete(`${FAQ_URL}/${ENTITY}/${id}`)
    return response.data
  },
  async import(data) {
    const response = await axiosInstance.post(`${FAQ_URL}/${ENTITY}/import`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  },
  async export() {
    const response = await axiosInstance.get(`${FAQ_URL}/${ENTITY}/export`)
    return response.data
  },
})
